import { Injectable } from '@angular/core';
import { LocalAccountService } from './localAccount.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private localAccountService: LocalAccountService,
    private api: ApiService
  ) { }

  loggedIn() {
    return !!this.localAccountService.getToken();
  }

  refresh() {
    return this.api.getRequest('refresh');
  }

  logOut() {
    return this.api.postRequestPromise('logout', {});
  }

}
